/**
 * Promise that resolves after the user has some interaction with the page.
 * Code executed after this will not influence WebVitals metrics.
 */
export const afterWebVitals: Promise<void> = new Promise<void>((resolve) => {
  function handle(event: Event) {
    resolve();
    setTimeout(() => {
      event.currentTarget?.removeEventListener(event.type, handle);
    }, 1000);
  }

  if (typeof window !== 'undefined') {
    const options = { passive: true };
    document.body.addEventListener('mousedown', handle, options);
    document.body.addEventListener('mousemove', handle, options);
    document.body.addEventListener('touchstart', handle, options);
    document.body.addEventListener('touchmove', handle, options);
    document.body.addEventListener('click', handle, options);
    document.addEventListener('scroll', handle, options);
    window.setTimeout(() => resolve(), 3500);
  }
});
